<script>
import options from './NykTag.options'
export default options
</script>

<template>
    <span :class="tagClasses" :aria-label="computedAriaLabel" role="status">
        <span class="nyk-tag__label">{{ title }}</span>
        <button
            v-if="closable"
            type="button"
            class="nyk-tag__close"
            :aria-label="closeButtonAriaLabel"
            @click="handleClose">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                <path d="M11 1L1 11M1 1l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
        </button>
    </span>
</template>
